
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
  import {
    productscheduleProductList
  } from "@/api/order"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate
    }
  })

  export default class ProductList extends Vue {
    private keywords = ''
    private state = null
    private statelist = [
      {value:null,label:'全部'},
      {value:-1,label:'待提交'},
      {value:0,label:'待完善'},
      {value:1,label:'待审核'},
      {value:3,label:'审核不通过'},
      {value:2,label:'审核通过'},
    ]
    private tanleloading = false
    private tablelist:any = []
		private pageNo = 1
		private pageSize = 10
		private total = 0
    private defaultImg = 'http://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/image/9d444a0d810d7945de8af64ae2cd8a9.png'
    private stateClass = {
      0:'color-f56c6c',
      1:'',
      2:'color-67c23a',
      3:'color-f56c6c'
    }


    private mounted () {
      if(this.$route.params.name){
        this.keywords = decodeURI(this.$route.params.name)||''
      }
      this.gettablelist()
    }

    

    private todetails(row,index,type){
      let query:any = {
        id:row.Id,
        index:index,
        flowTab:'',
        type:type
      }
      if(index==4){
        if(row.ProductLogisticsState!=2||row.ProductCheckWarehouseState==2||(row.ProductLogisticsState==2&&row.ProductCheckWarehouseState==0)){
          query.flowTab = '1'
        }else{
          query.flowTab = '2'
        }
      }
      this.$router.push({
        path:'auditScheduleShopDetails',
        query:query
      })
    }
    private clearSearch(){
      this.keywords = ''
      this.state = null
      this.changeCurrent(1)
    }
    private doSearch(){
      this.changeCurrent(1)
    }
    private changeCurrent(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tanleloading = true
        let res:any = await productscheduleProductList({
          Keywords:this.keywords,
          State:this.state,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tanleloading = false
      }
    }
  }
